// import React, { useState } from 'react';
// import { useQuery, useMutation, useQueryClient } from 'react-query';
// import {
//   Box, Button, Table, Thead, Tbody, Tr, Th, Td, VStack, HStack, Input, useToast, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton,
//   FormControl, FormLabel, FormErrorMessage, Select, AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay,
// } from '@chakra-ui/react';
// import SettingsService from '../../../services/SettingsService';

// const SettingsManager = () => {
//   const toast = useToast();
//   const queryClient = useQueryClient();

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
//   const [modalData, setModalData] = useState({ type: '', id: null, data: {}, entity: '' });
//   const [currentEntity, setCurrentEntity] = useState('appShareLink');
//   const [errors, setErrors] = useState({});
//   const [selectedId, setSelectedId] = useState(null);
//   const cancelRef = React.useRef();

//   const entityQueryMap = {
//     appShareLink: 'appShareLinks',
//     phoneNumber: 'phoneNumbers',
//     privacyPolicy: 'privacyPolicies',
//     socialMediaLink: 'socialMediaLinks',
//   };

//   const { data: appShareLinks } = useQuery('appShareLinks', SettingsService.getAllAppShareLinks);
//   const { data: phoneNumbers } = useQuery('phoneNumbers', SettingsService.getAllPhoneNumbers);
//   const { data: privacyPolicies } = useQuery('privacyPolicies', SettingsService.getAllPrivacyPolicies);
//   const { data: socialMediaLinks } = useQuery('socialMediaLinks', SettingsService.getAllSocialMediaLinks);

//   const mutation = useMutation(
//     async (params) => {
//       const { type, id, data, entity } = params;
//       switch (type) {
//         case 'create':
//           return SettingsService[`create${entity.charAt(0).toUpperCase() + entity.slice(1)}`](data);
//         case 'update':
//           return SettingsService[`update${entity.charAt(0).toUpperCase() + entity.slice(1)}`](id, data);
//         case 'delete':
//           return SettingsService[`delete${entity.charAt(0).toUpperCase() + entity.slice(1)}`](id);
//         default:
//           throw new Error('Invalid action');
//       }
//     },
//     {
//       onSuccess: () => {
//         toast({ title: 'Operation successful', status: 'success', duration: 3000, isClosable: true });
//         queryClient.invalidateQueries(entityQueryMap[currentEntity]);
//         setIsModalOpen(false);
//         setIsDeleteDialogOpen(false);
//       },
//       onError: (error) => {
//         const errorMessage = error.response?.data?.message || 'Operation failed';
//         toast({ title: 'Operation failed', description: errorMessage, status: 'error', duration: 3000, isClosable: true });
//       },
//     }
//   );

//   const handleAction = (type, entity, id = null, data = {}) => {
//     setErrors({});
//     if (type === 'delete') {
//       setSelectedId(id);
//       setIsDeleteDialogOpen(true);
//     } else {
//       setModalData({ type, id, data, entity });
//       setIsModalOpen(true);
//     }
//   };

//   const handleSubmit = () => {
//     const { type, id, data, entity } = modalData;
//     const newErrors = {};
//     const entityFields = {
//       appShareLink: ['en', 'ar'],
//       phoneNumber: ['en', 'ar'],
//       privacyPolicy: ['en', 'ar'],
//       socialMediaLink: ['en', 'ar'],
//     };

//     entityFields[currentEntity].forEach(field => {
//       if (!data[field]) {
//         newErrors[field] = 'This field is required';
//       }
//     });

//     if (Object.keys(newErrors).length) {
//       setErrors(newErrors);
//     } else {
//       mutation.mutate({ type, id, data, entity });
//     }
//   };

//   const handleDelete = () => {
//     if (selectedId) {
//       mutation.mutate({ type: 'delete', id: selectedId, entity: currentEntity });
//     } else {
//       toast({ title: 'Error', description: 'No item selected for deletion', status: 'error', duration: 3000, isClosable: true });
//     }
//   };

//   const renderTableData = () => {
//     let data = [];
//     switch (currentEntity) {
//       case 'appShareLink':
//         data = appShareLinks?.data || [];
//         break;
//       case 'phoneNumber':
//         data = phoneNumbers?.data || [];
//         break;
//       case 'privacyPolicy':
//         data = privacyPolicies?.data || [];
//         break;
//       case 'socialMediaLink':
//         data = socialMediaLinks?.data || [];
//         break;
//       default:
//         data = [];
//     }
//     return data;
//   };

//   const renderModalContent = () => {
//     const entityFields = {
//       appShareLink: ['en', 'ar'],
//       phoneNumber: ['en', 'ar'],
//       privacyPolicy: ['en', 'ar'],
//       socialMediaLink: ['en', 'ar'],
//     };
//     return entityFields[currentEntity].map((field) => (
//       <FormControl key={field} isInvalid={errors[field]}>
//         <FormLabel>{field.toUpperCase()}</FormLabel>
//         <Input
//           placeholder={field}
//           value={modalData.data[field] || ''}
//           onChange={(e) => setModalData({ ...modalData, data: { ...modalData.data, [field]: e.target.value } })}
//         />
//         {errors[field] && <FormErrorMessage>{errors[field]}</FormErrorMessage>}
//       </FormControl>
//     ));
//   };

//   return (
//     <Box p={4}>
//       <HStack spacing={4} mb={4}>
//         <Button colorScheme="blue" onClick={() => setCurrentEntity('appShareLink')}>App Share Link</Button>
//         <Button colorScheme="blue" onClick={() => setCurrentEntity('phoneNumber')}>Phone Number</Button>
//         <Button colorScheme="blue" onClick={() => setCurrentEntity('privacyPolicy')}>Privacy Policy</Button>
//         <Button colorScheme="blue" onClick={() => setCurrentEntity('socialMediaLink')}>Social Media Link</Button>
//       </HStack>
//       <Button colorScheme="blue" onClick={() => handleAction('create', currentEntity)}>Create {currentEntity}</Button>

//       <Box overflowX="auto">
//         <Table mt={4} variant="simple" size="sm">
//           <Thead>
//             <Tr>
//               {/* <Th>ID</Th> */}
//               <Th>EN</Th>
//               <Th>AR</Th>
//               <Th>Actions</Th>
//             </Tr>
//           </Thead>
//           <Tbody>
//             {renderTableData().map((item) => (
//               <Tr key={item._id}>
//                 {/* <Td>{item._id}</Td> */}
//                 <Td>{item.en}</Td>
//                 <Td>{item.ar}</Td>
//                 <Td>
//                   <Button colorScheme="yellow" onClick={() => handleAction('update', currentEntity, item._id, item)}>Edit</Button>
//                   <Button colorScheme="red" ml={2} onClick={() => handleAction('delete', currentEntity, item._id)}>Delete</Button>
//                 </Td>
//               </Tr>
//             ))}
//           </Tbody>
//         </Table>
//       </Box>

//       <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>{modalData.type === 'create' ? 'Create' : 'Edit'} {currentEntity}</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             <VStack spacing={4}>
//               {renderModalContent()}
//             </VStack>
//           </ModalBody>
//           <ModalFooter>
//             <Button colorScheme="blue" onClick={handleSubmit}>{modalData.type === 'create' ? 'Create' : 'Update'}</Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>

//       <AlertDialog
//         isOpen={isDeleteDialogOpen}
//         leastDestructiveRef={cancelRef}
//         onClose={() => setIsDeleteDialogOpen(false)}
//       >
//         <AlertDialogOverlay>
//           <AlertDialogContent>
//             <AlertDialogHeader fontSize="lg" fontWeight="bold">
//               Delete Item
//             </AlertDialogHeader>

//             <AlertDialogBody>
//               Are you sure? You can't undo this action.
//             </AlertDialogBody>

//             <AlertDialogFooter>
//               <Button ref={cancelRef} onClick={() => setIsDeleteDialogOpen(false)}>
//                 Cancel
//               </Button>
//               <Button colorScheme="red" onClick={handleDelete} ml={3}>
//                 Delete
//               </Button>
//             </AlertDialogFooter>
//           </AlertDialogContent>
//         </AlertDialogOverlay>
//       </AlertDialog>
//     </Box>
//   );
// };

// export default SettingsManager;










// import React, { useState, useRef } from 'react';
// import { useQuery, useMutation, useQueryClient } from 'react-query';
// import {
//   Box, Button, Table, Thead, Tbody, Tr, Th, Td, VStack, HStack, Input, useToast, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton,
//   FormControl, FormLabel, FormErrorMessage, AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay,
// } from '@chakra-ui/react';
// import { Editor } from 'primereact/editor';
// import SettingsService from '../../../services/SettingsService';
// import 'quill/dist/quill.bubble.css'; // For the 'bubble' theme

// const SettingsManager = () => {
//   const toast = useToast();
//   const queryClient = useQueryClient();

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
//   const [modalData, setModalData] = useState({ type: '', id: null, data: {}, entity: '' });
//   const [currentEntity, setCurrentEntity] = useState('appShareLink');
//   const [errors, setErrors] = useState({});
//   const [selectedId, setSelectedId] = useState(null);
//   const cancelRef = useRef();

//   const entityQueryMap = {
//     appShareLink: 'appShareLinks',
//     phoneNumber: 'phoneNumbers',
//     privacyPolicy: 'privacyPolicies',
//     socialMediaLink: 'socialMediaLinks',
//   };

//   const { data: appShareLinks } = useQuery('appShareLinks', SettingsService.getAllAppShareLinks);
//   const { data: phoneNumbers } = useQuery('phoneNumbers', SettingsService.getAllPhoneNumbers);
//   const { data: privacyPolicies } = useQuery('privacyPolicies', SettingsService.getAllPrivacyPolicies);
//   const { data: socialMediaLinks } = useQuery('socialMediaLinks', SettingsService.getAllSocialMediaLinks);

//   const mutation = useMutation(
//     async (params) => {
//       const { type, id, data, entity } = params;
//       switch (type) {
//         case 'create':
//           return SettingsService[`create${entity.charAt(0).toUpperCase() + entity.slice(1)}`](data);
//         case 'update':
//           return SettingsService[`update${entity.charAt(0).toUpperCase() + entity.slice(1)}`](id, data);
//         case 'delete':
//           return SettingsService[`delete${entity.charAt(0).toUpperCase() + entity.slice(1)}`](id);
//         default:
//           throw new Error('Invalid action');
//       }
//     },
//     {
//       onSuccess: () => {
//         toast({ title: 'Operation successful', status: 'success', duration: 3000, isClosable: true });
//         queryClient.invalidateQueries(entityQueryMap[currentEntity]);
//         setIsModalOpen(false);
//         setIsDeleteDialogOpen(false);
//       },
//       onError: (error) => {
//         const errorMessage = error.response?.data?.message || 'Operation failed';
//         toast({ title: 'Operation failed', description: errorMessage, status: 'error', duration: 3000, isClosable: true });
//       },
//     }
//   );

//   const handleAction = (type, entity, id = null, data = {}) => {
//     setErrors({});
//     if (type === 'delete') {
//       setSelectedId(id);
//       setIsDeleteDialogOpen(true);
//     } else {
//       setModalData({ type, id, data, entity });
//       setIsModalOpen(true);
//     }
//   };

//   const handleSubmit = () => {
//     const { type, id, data, entity } = modalData;
//     const newErrors = {};
//     const entityFields = {
//       appShareLink: ['en', 'ar'],
//       phoneNumber: ['en', 'ar'],
//       privacyPolicy: ['en', 'ar'],
//       socialMediaLink: ['en', 'ar'],
//     };

//     entityFields[currentEntity].forEach(field => {
//       if (!data[field]) {
//         newErrors[field] = 'This field is required';
//       }
//     });

//     if (Object.keys(newErrors).length) {
//       setErrors(newErrors);
//     } else {
//       mutation.mutate({ type, id, data, entity });
//     }
//   };

//   const handleDelete = () => {
//     if (selectedId) {
//       mutation.mutate({ type: 'delete', id: selectedId, entity: currentEntity });
//     } else {
//       toast({ title: 'Error', description: 'No item selected for deletion', status: 'error', duration: 3000, isClosable: true });
//     }
//   };

//   const renderTableData = () => {
//     let data = [];
//     switch (currentEntity) {
//       case 'appShareLink':
//         data = appShareLinks?.data || [];
//         break;
//       case 'phoneNumber':
//         data = phoneNumbers?.data || [];
//         break;
//       case 'privacyPolicy':
//         data = privacyPolicies?.data || [];
//         break;
//       case 'socialMediaLink':
//         data = socialMediaLinks?.data || [];
//         break;
//       default:
//         data = [];
//     }
//     return data;
//   };

//   const renderModalContent = () => {
//     const entityFields = {
//       appShareLink: ['en', 'ar'],
//       phoneNumber: ['en', 'ar'],
//       privacyPolicy: ['en', 'ar'],
//       socialMediaLink: ['en', 'ar'],
//     };

//     return entityFields[currentEntity].map((field) => (
//       <FormControl key={field} isInvalid={errors[field]}>
//         <FormLabel>{field.toUpperCase()}</FormLabel>
//         {currentEntity === 'privacyPolicy' ? (
//           <Editor
//             style={{ height: '200px' }}
//             value={modalData.data[field] || ''}
//             onTextChange={(e) => setModalData({ ...modalData, data: { ...modalData.data, [field]: e.htmlValue } })}
//           />
//         ) : (
//           <Input
//             placeholder={field}
//             value={modalData.data[field] || ''}
//             onChange={(e) => setModalData({ ...modalData, data: { ...modalData.data, [field]: e.target.value } })}
//           />
//         )}
//         {errors[field] && <FormErrorMessage>{errors[field]}</FormErrorMessage>}
//       </FormControl>
//     ));
//   };

//   return (
//     <Box p={4}>
//       <HStack spacing={4} mb={4}>
//         <Button colorScheme="blue" onClick={() => setCurrentEntity('appShareLink')}>App Share Link</Button>
//         <Button colorScheme="blue" onClick={() => setCurrentEntity('phoneNumber')}>Phone Number</Button>
//         <Button colorScheme="blue" onClick={() => setCurrentEntity('privacyPolicy')}>Privacy Policy</Button>
//         <Button colorScheme="blue" onClick={() => setCurrentEntity('socialMediaLink')}>Social Media Link</Button>
//       </HStack>
//       <Button colorScheme="blue" onClick={() => handleAction('create', currentEntity)}>Create {currentEntity}</Button>

//       <Box overflowX="auto">
//         <Table mt={4} variant="simple" size="sm">
//           <Thead>
//             <Tr>
//               <Th>EN</Th>
//               <Th>AR</Th>
//               <Th>Actions</Th>
//             </Tr>
//           </Thead>
//           <Tbody>
//             {renderTableData().map((item) => (
//               <Tr key={item._id}>
//                 <Td>{item.en}</Td>
//                 <Td>{item.ar}</Td>
//                 <Td>
//                   <Button colorScheme="yellow" onClick={() => handleAction('update', currentEntity, item._id, item)}>Edit</Button>
//                   <Button colorScheme="red" ml={2} onClick={() => handleAction('delete', currentEntity, item._id)}>Delete</Button>
//                 </Td>
//               </Tr>
//             ))}
//           </Tbody>
//         </Table>
//       </Box>

//       <Modal isOpen={isModalOpen} size={'full'} onClose={() => setIsModalOpen(false)}>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>{modalData.type === 'create' ? 'Create' : 'Edit'} {currentEntity}</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             <VStack spacing={4}>
//               {renderModalContent()}
//             </VStack>
//           </ModalBody>
//           <ModalFooter>
//             <Button colorScheme="blue" onClick={handleSubmit}>{modalData.type === 'create' ? 'Create' : 'Update'}</Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>

//       <AlertDialog
//         isOpen={isDeleteDialogOpen}
//         leastDestructiveRef={cancelRef}
//         onClose={() => setIsDeleteDialogOpen(false)}
//       >
//         <AlertDialogOverlay>
//           <AlertDialogContent>
//             <AlertDialogHeader fontSize="lg" fontWeight="bold">
//               Delete Item
//             </AlertDialogHeader>
//             <AlertDialogBody>
//               Are you sure? You can't undo this action.
//             </AlertDialogBody>
//             <AlertDialogFooter>
//               <Button ref={cancelRef} onClick={() => setIsDeleteDialogOpen(false)}>
//                 Cancel
//               </Button>
//               <Button colorScheme="red" onClick={handleDelete} ml={3}>
//                 Delete
//               </Button>
//             </AlertDialogFooter>
//           </AlertDialogContent>
//         </AlertDialogOverlay>
//       </AlertDialog>
//     </Box>
//   );
// };

// export default SettingsManager;










import React, { useState, useRef } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import {
  Box, Button, Table, Thead, Tbody, Tr, Th, Td, VStack, HStack, Input, useToast, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton,
  FormControl, FormLabel, FormErrorMessage, AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay,
} from '@chakra-ui/react';
import { Editor } from 'primereact/editor';
import SettingsService from '../../../services/SettingsService';
import 'quill/dist/quill.bubble.css'; // For the 'bubble' theme

const SettingsManager = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [modalData, setModalData] = useState({ type: '', id: null, data: {}, entity: '' });
  const [currentEntity, setCurrentEntity] = useState('appShareLink');
  const [errors, setErrors] = useState({});
  const [selectedId, setSelectedId] = useState(null);
  const cancelRef = useRef();

  const entityQueryMap = {
    appShareLink: 'appShareLinks',
    phoneNumber: 'phoneNumbers',
    privacyPolicy: 'privacyPolicies',
    socialMediaLink: 'socialMediaLinks',
  };

  const { data: appShareLinks } = useQuery('appShareLinks', SettingsService.getAllAppShareLinks);
  const { data: phoneNumbers } = useQuery('phoneNumbers', SettingsService.getAllPhoneNumbers);
  const { data: privacyPolicies } = useQuery('privacyPolicies', SettingsService.getAllPrivacyPolicies);
  const { data: socialMediaLinks } = useQuery('socialMediaLinks', SettingsService.getAllSocialMediaLinks);

  const mutation = useMutation(
    async (params) => {
      const { type, id, data, entity } = params;
      switch (type) {
        case 'create':
          return SettingsService[`create${entity.charAt(0).toUpperCase() + entity.slice(1)}`](data);
        case 'update':
          return SettingsService[`update${entity.charAt(0).toUpperCase() + entity.slice(1)}`](id, data);
        case 'delete':
          return SettingsService[`delete${entity.charAt(0).toUpperCase() + entity.slice(1)}`](id);
        default:
          throw new Error('Invalid action');
      }
    },
    {
      onSuccess: () => {
        toast({ title: 'Operation successful', status: 'success', duration: 3000, isClosable: true });
        queryClient.invalidateQueries(entityQueryMap[currentEntity]);
        setIsModalOpen(false);
        setIsDeleteDialogOpen(false);
      },
      onError: (error) => {
        const errorMessage = error.response?.data?.message || 'Operation failed';
        toast({ title: 'Operation failed', description: errorMessage, status: 'error', duration: 3000, isClosable: true });
      },
    }
  );

  const handleAction = (type, entity, id = null, data = {}) => {
    setErrors({});
    if (type === 'delete') {
      setSelectedId(id);
      setIsDeleteDialogOpen(true);
    } else {
      setModalData({ type, id, data, entity });
      setIsModalOpen(true);
    }
  };

  const handleSubmit = () => {
    const { type, id, data, entity } = modalData;
    const newErrors = {};
    const entityFields = {
      appShareLink: ['en', 'ar'],
      phoneNumber: ['en', 'ar'],
      privacyPolicy: ['en', 'ar'],
      socialMediaLink: ['en', 'ar'],
    };

    entityFields[currentEntity].forEach(field => {
      if (!data[field]) {
        newErrors[field] = 'This field is required';
      }
    });

    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
    } else {
      mutation.mutate({ type, id, data, entity });
    }
  };

  const handleDelete = () => {
    if (selectedId) {
      mutation.mutate({ type: 'delete', id: selectedId, entity: currentEntity });
    } else {
      toast({ title: 'Error', description: 'No item selected for deletion', status: 'error', duration: 3000, isClosable: true });
    }
  };

  const renderTableData = () => {
    let data = [];
    switch (currentEntity) {
      case 'appShareLink':
        data = appShareLinks?.data || [];
        break;
      case 'phoneNumber':
        data = phoneNumbers?.data || [];
        break;
      case 'privacyPolicy':
        data = privacyPolicies?.data || [];
        break;
      case 'socialMediaLink':
        data = socialMediaLinks?.data || [];
        break;
      default:
        data = [];
    }

    return data.map((item) => (
      <Tr key={item._id}>
        <Td>
          {currentEntity === 'privacyPolicy' ? (
            <Box dangerouslySetInnerHTML={{ __html: item.en }} />
          ) : (
            item.en
          )}
        </Td>
        <Td>
          {currentEntity === 'privacyPolicy' ? (
            <Box dangerouslySetInnerHTML={{ __html: item.ar }} />
          ) : (
            item.ar
          )}
        </Td>
        <Td>
          <Button colorScheme="yellow" onClick={() => handleAction('update', currentEntity, item._id, item)}>Edit</Button>
          <Button colorScheme="red" ml={2} onClick={() => handleAction('delete', currentEntity, item._id)}>Delete</Button>
        </Td>
      </Tr>
    ));
  };

  const renderModalContent = () => {
    const entityFields = {
      appShareLink: ['en', 'ar'],
      phoneNumber: ['en', 'ar'],
      privacyPolicy: ['en', 'ar'],
      socialMediaLink: ['en', 'ar'],
    };

    return entityFields[currentEntity].map((field) => (
      <FormControl key={field} isInvalid={errors[field]}>
        <FormLabel>{field.toUpperCase()}</FormLabel>
        {currentEntity === 'privacyPolicy' ? (
          <Editor
            style={{ height: '200px' }}
            value={modalData.data[field] || ''}
            onTextChange={(e) => setModalData({ ...modalData, data: { ...modalData.data, [field]: e.htmlValue } })}
          />
        ) : (
          <Input
            placeholder={field}
            value={modalData.data[field] || ''}
            onChange={(e) => setModalData({ ...modalData, data: { ...modalData.data, [field]: e.target.value } })}
          />
        )}
        {errors[field] && <FormErrorMessage>{errors[field]}</FormErrorMessage>}
      </FormControl>
    ));
  };

  return (
    <Box p={4}>
      <HStack spacing={4} mb={4}>
        <Button colorScheme="blue" onClick={() => setCurrentEntity('appShareLink')}>App Share Link</Button>
        <Button colorScheme="blue" onClick={() => setCurrentEntity('phoneNumber')}>Phone Number</Button>
        <Button colorScheme="blue" onClick={() => setCurrentEntity('privacyPolicy')}>Privacy Policy</Button>
        <Button colorScheme="blue" onClick={() => setCurrentEntity('socialMediaLink')}>Social Media Link</Button>
      </HStack>
      <Button colorScheme="blue" onClick={() => handleAction('create', currentEntity)}>Create {currentEntity}</Button>

      <Box overflowX="auto">
        <Table mt={4} variant="simple" size="sm">
          <Thead>
            <Tr>
              <Th>EN</Th>
              <Th>AR</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {renderTableData()}
          </Tbody>
        </Table>
      </Box>

      <Modal isOpen={isModalOpen} size={'full'} onClose={() => setIsModalOpen(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{modalData.type === 'create' ? 'Create' : 'Edit'} {currentEntity}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4}>
              {renderModalContent()}
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={handleSubmit}>{modalData.type === 'create' ? 'Create' : 'Create'}</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <AlertDialog
        isOpen={isDeleteDialogOpen}
        leastDestructiveRef={cancelRef}
        onClose={() => setIsDeleteDialogOpen(false)}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Item
            </AlertDialogHeader>
            <AlertDialogBody>
              Are you sure? You can't undo this action.
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={() => setIsDeleteDialogOpen(false)}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default SettingsManager;
